import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=22dced10"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"
import style0 from "./_id.vue?vue&type=style&index=0&id=22dced10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PostMeta: require('/opt/build/repo/components/post/Meta.vue').default,BlogLayout: require('/opt/build/repo/components/blog/Layout.vue').default})
